<template>
  <button
    class="def-buy-secondary"
    :class="{ 'def-buy-secondary_in-basket': basketStore.inBasket(id) }"
    :disabled="disabled || isRequestSend"
    @click="handlerBuy"
  >
    <!-- product in basket -->
    <!--    <svg v-if="inBasket(id)" class="def-buy__icon"><use xlink:href="#svg-check"></use></svg>-->
    <slot v-if="basketStore.inBasket(id)" name="inBasket" />

    <!-- add product to basket -->
    <slot v-else />
    <!--    <svg v-else class="def-buy__icon"><use xlink:href="#svg-basket"></use></svg>-->
  </button>
</template>

<script>
import gsap from 'gsap';
import useModal from '@use/useModal/useModal';
import useBasketModal from '@use/useBasketModal';
import { useBasketStore } from '@/storePinia/stores/basket';

import Analytics from '@/utils/Analytics/Analytics';
import { scrollPageTo } from '@/utils/helpers';

export default {
  props: {
    result: {
      type: Object,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      isRequestSend: false,
      modal: useModal(),
      basketModal: useBasketModal(),
      basketStore: useBasketStore(),
    };
  },
  computed: {
    id() {
      return this.result?.offer?.id || this.result?.id;
    },
  },
  methods: {
    createAnimation() {
      try {
        const div = document.createElement('div');
        div.classList.add('buy-animation');
        div.style.backgroundImage = `url(${this.result.picture.src})`;
        div.style.zIndex = 2001;

        const baskets = document.querySelectorAll('.small-basket-control');

        if (!baskets.length) return;

        const smallBasket = baskets.length === 2 ? baskets[1] : baskets[0];
        const rect = smallBasket.getBoundingClientRect();

        document.body.appendChild(div);

        gsap
          .timeline({
            defaults: {
              duration: 1,
            },
            onComplete() {
              div.remove();
            },
          })
          .to(div, {
            top: innerHeight / 2,
            left: innerWidth / 2,
            width: 100,
            height: 100,
            xPercent: -50,
            yPercent: -100,
            ease: 'power1.in',
          })
          .to(div, {
            top: rect.top,
            left: rect.left,
            width: 50,
            height: 50,
            borderWidth: 1,
            xPercent: -20,
            yPercent: -20,
            ease: 'none',
          });
      } catch (err) {
        console.error(err);
      }
    },
    async handlerBuy() {
      if (!this.basketStore.inBasket(this.id)) {
        this.isRequestSend = true;
        this.createAnimation();
        await this.basketStore.add({
          id: this.id,
          count: this.result?.price?.quantity,
          price: this.result?.price?.price,
          isProductWithoutNominal: this.result?.isProductWithoutNominal,
        });
        Analytics.addToBasket(this.result);
        scrollPageTo(0);
        this.isRequestSend = false;
      } else {
        await this.modal.hide();
        this.basketModal.open();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.def-buy-secondary {
  &_in-basket {
  }
}
</style>
